module.exports = __webpack_public_path__ + "media/images/emblems/Forel-coat_of_arms-41ea000d415afdcb7e0a213ba873ffea.svg";